import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from '../context/context';
import { setUser, setUserProfile } from '../context/user/actions';
import { insertTokenIntoHttp } from '../utils/token';

export const useLogout = () => {
  const [, dispatch] = useContext<any>(AppContext);
  const history = useHistory();

  return () => {
    dispatch(setUser(null));
    dispatch(setUserProfile(null));
    history.push('/');
    localStorage.clear();
    sessionStorage.clear();
    insertTokenIntoHttp(null);
  };
};
